module.exports = __webpack_public_path__ + "InterstateWGL-Bold.69024334c1d5c7d09542.woff";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/InterstateWGL-Bold.woff
// module id = ../../../../../src/assets/layout/fonts/InterstateWGL-Bold.woff
// module chunks = styles